import PageMasthead from '../../components/PageMasthead'
import { useTitle } from '../../components/TitleProvider'

// Interim holding page for the Reports tab (EN-327). Airbyte/Snowflake is being
// switched off, so the embedded Preset dashboards can no longer be kept up to
// date. Rather than let them go stale, the tab shows this message for every
// organisation and user while reporting moves to the new Monthly Moderation
// Reports (a separate Service Delivery workstream). The Preset teardown itself
// is tracked under EN-318.
export default function ReportHoldingPage() {
    useTitle('Reporting')

    return (
        <>
            <PageMasthead title="Reporting" />
            <div className="m-10">
                <div className="bg-white">
                    <div className="mx-auto max-w-3xl py-16 px-4 text-center flex flex-col items-center sm:px-6 lg:py-24 lg:px-8">
                        <article className="prose lg:prose-xl">
                            <p>
                            Exciting news — reporting is getting an upgrade. We're moving to Monthly
                            Reports, giving you a clearer, more structured view of your
                            comment performance each month. Watch out for your first report landing
                            soon. Got a question in the meantime? Drop us a line at{' '}
                            <a href="mailto:support@arwen.ai">
                                <span className="text-arwen-600 underline">support@arwen.ai</span>
                            </a>
                            .
                        </p>
                    </article>
                </div>
            </div>
            </div>
        </>
    )
}
